"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_DISABLE_ETRACKER_TRACKING = exports.DATA_DISABLE_MATOMO_TRACKING = exports.DATA_BLACK_ELEMENT = exports.DATA_BS_DISMISS = exports.DATA_BS_TOGGLE = exports.DATA_FORM_OUTRO_BODYTEXT = exports.DATA_FORM_OUTRO_HEADLINE = exports.DATA_FORM_OUTRO = exports.DATA_FORM_STATIC_TEXT = exports.DATA_FORM_BACK = exports.DATA_FORM_FIELD_ERROR = exports.DATA_FORM_FIELD_WRAP = exports.DATA_FORM = exports.DATA_REMOVE_FILE = exports.DATA_FILEUPLOAD_INPUT = exports.DATA_FILEHASH = exports.DATA_FILESIZE = exports.DATA_FILENAME = exports.DATA_FILEUPLOAD_ITEM = exports.DATA_FILEUPLOAD_TEMPLATE = exports.DATA_FILEUPLOADS = exports.DATA_FILEUPLOAD_DROP_AREA = exports.DATA_FILEUPLOAD = exports.D_MD_BLOCK = exports.D_NONE = exports.HIDDEN = exports.DATA_PROCESS_PROGRESS_AMOUNT = exports.DATA_PROCESS_PROGRESS = exports.DATA_PROCESS_TRANSITION_RIGHT = exports.DATA_PROCESS_TRANSITION_LEFT = exports.DATA_PROCESS_TRANSITION = exports.DATA_SET_INITIAL_HEIGHT = exports.DATA_SLIDER_MEDIA_GALLERY_LARGE = exports.DATA_SLIDER_MEDIA_GALLERY_MEDIUM = exports.DATA_SLIDER_MEDIA_GALLERY_SMALL = exports.DATA_SLIDER_COLLEAGUES = exports.DATA_SLIDER_KEYFACTS = exports.DATA_ACCORDION = exports.DATA_HOVER_IN_VIEWPORT = exports.DATA_SVG_ANIMATE = exports.DATA_PAGE_INTRO_PROCESS = exports.DATA_PAGE_INTRO_LINETYPE = exports.DATA_PAGE_INTRO_BUTTON = exports.DATA_PAGE_INTRO_BLOCK_RIGHT = exports.DATA_PAGE_INTRO_HEADLINE = exports.DATA_PAGE_INTRO = exports.DATA_ROTATING_BUTTON = exports.DATA_NAVBAR_MAIN_LOGO = exports.DATA_NAVBAR_MAIN_BUTTON = exports.DATA_NAVBAR_MAIN = void 0;
exports.OBJECT_STORE = exports.INDEXED_DB_NAME = exports.DATA_FORM_CLOSE_BUTTON = exports.DATA_ROTATING = exports.DATA_CONTACT_BUTTON = exports.DATA_STICKY_LEAD_BUTTON = exports.DATA_BODY_CONTENT = void 0;
exports.DATA_NAVBAR_MAIN = 'data-navbar-main';
exports.DATA_NAVBAR_MAIN_BUTTON = 'data-navbar-main-button';
exports.DATA_NAVBAR_MAIN_LOGO = 'data-navbar-main-logo';
exports.DATA_ROTATING_BUTTON = 'data-rotating-button';
exports.DATA_PAGE_INTRO = 'data-page-intro';
exports.DATA_PAGE_INTRO_HEADLINE = 'data-page-intro-headline';
exports.DATA_PAGE_INTRO_BLOCK_RIGHT = 'data-page-intro-block-right';
exports.DATA_PAGE_INTRO_BUTTON = 'data-page-intro-button';
exports.DATA_PAGE_INTRO_LINETYPE = 'data-page-intro-linetype';
exports.DATA_PAGE_INTRO_PROCESS = 'data-page-intro-process';
exports.DATA_SVG_ANIMATE = 'data-svg-animate';
exports.DATA_HOVER_IN_VIEWPORT = 'data-hover-in-viewport';
exports.DATA_ACCORDION = 'data-bs-toggle';
exports.DATA_SLIDER_KEYFACTS = 'data-slider-keyfacts';
exports.DATA_SLIDER_COLLEAGUES = 'data-slider-colleagues';
exports.DATA_SLIDER_MEDIA_GALLERY_SMALL = 'data-slider-media-small';
exports.DATA_SLIDER_MEDIA_GALLERY_MEDIUM = 'data-slider-media-medium';
exports.DATA_SLIDER_MEDIA_GALLERY_LARGE = 'data-slider-media-large';
exports.DATA_SET_INITIAL_HEIGHT = 'data-set-initial-height';
exports.DATA_PROCESS_TRANSITION = 'data-process-transition';
exports.DATA_PROCESS_TRANSITION_LEFT = ' data-process-transition-left';
exports.DATA_PROCESS_TRANSITION_RIGHT = ' data-process-transition-right';
exports.DATA_PROCESS_PROGRESS = 'data-process-progress';
exports.DATA_PROCESS_PROGRESS_AMOUNT = 'data-process-progress-amount';
// COMMON CLASSES
exports.HIDDEN = 'hidden';
exports.D_NONE = 'd-none';
exports.D_MD_BLOCK = 'd-md-block';
exports.DATA_FILEUPLOAD = 'data-fileupload';
exports.DATA_FILEUPLOAD_DROP_AREA = 'data-fileupload-drop-area';
exports.DATA_FILEUPLOADS = 'data-fileuploads';
exports.DATA_FILEUPLOAD_TEMPLATE = 'data-fileupload-template';
exports.DATA_FILEUPLOAD_ITEM = 'data-fileupload-item';
exports.DATA_FILENAME = 'data-filename';
exports.DATA_FILESIZE = 'data-filesize';
exports.DATA_FILEHASH = 'data-filehash';
exports.DATA_FILEUPLOAD_INPUT = 'data-fileupload-input';
exports.DATA_REMOVE_FILE = 'data-remove-file';
exports.DATA_FORM = 'data-form';
exports.DATA_FORM_FIELD_WRAP = 'data-form-field-wrap';
exports.DATA_FORM_FIELD_ERROR = 'data-form-field-error';
exports.DATA_FORM_BACK = 'data-form-back';
exports.DATA_FORM_STATIC_TEXT = 'data-form-static-text';
// Form Outro
exports.DATA_FORM_OUTRO = 'data-form-outro';
exports.DATA_FORM_OUTRO_HEADLINE = 'data-form-outro-headline';
exports.DATA_FORM_OUTRO_BODYTEXT = 'data-form-outro-bodytext';
// Bootstrap
exports.DATA_BS_TOGGLE = 'data-bs-toggle';
exports.DATA_BS_DISMISS = 'data-bs-dismiss';
// Switch white to black element
exports.DATA_BLACK_ELEMENT = 'data-black-element';
// Disable Tracking Links
exports.DATA_DISABLE_MATOMO_TRACKING = 'data-disable-matomo-tracking';
exports.DATA_DISABLE_ETRACKER_TRACKING = 'data-disable-etracker-tracking';
// Body Content Wrapper
exports.DATA_BODY_CONTENT = 'data-body-content';
// Sticky Lead
exports.DATA_STICKY_LEAD_BUTTON = 'data-sticky-lead-button';
// Contact button
exports.DATA_CONTACT_BUTTON = 'data-contact-button';
exports.DATA_ROTATING = 'is-rotating';
exports.DATA_FORM_CLOSE_BUTTON = 'data-form-close';
// Indexed Database (for handling file upload in application form)
exports.INDEXED_DB_NAME = 'ww_application';
exports.OBJECT_STORE = 'uploadedFiles';
